import React, { useEffect, useState } from "react";
import Logo from "./Logo";
import { Phone, Menu, X } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../../lib/contact";

const links = [
  { href: "#anasayfa", label: "Anasayfa" },
  { href: "#hakkimizda", label: "Hakkımızda" },
  { href: "#urunler", label: "Ürünlerimiz" },
  { href: "#fiyat-listesi", label: "Fiyat Listesi" },
  { href: "#ozellikler", label: "Özellikler" },
  { href: "#blog", label: "Blog" },
  { href: "#iletisim", label: "İletişim" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-slate-200 shadow-[0_2px_20px_-12px_rgba(10,25,47,0.25)]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="container mx-auto px-5 sm:px-8 max-w-7xl">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <a href="#anasayfa" className="shrink-0" data-testid="nav-logo-link">
            <Logo />
          </a>

          <nav className="hidden lg:flex items-center gap-9">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.replace("#", "")}`}
                className="text-sm font-medium text-slate-700 hover:text-[#0A192F] transition-colors relative after:absolute after:left-0 after:-bottom-1.5 after:h-[2px] after:w-0 after:bg-[#2563EB] hover:after:w-full after:transition-all after:duration-300"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href={`tel:${PHONE_TEL}`}
              data-testid="nav-phone-cta"
              className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[#0A192F] text-white px-5 py-2.5 text-sm font-semibold hover:bg-[#112240] transition-all duration-200 active:scale-95 shadow-sm"
            >
              <Phone className="w-4 h-4" strokeWidth={2.4} />
              {PHONE_DISPLAY}
            </a>
            <button
              type="button"
              aria-label="Menüyü aç/kapa"
              data-testid="nav-mobile-toggle"
              onClick={() => setOpen((v) => !v)}
              className="lg:hidden inline-flex items-center justify-center w-11 h-11 rounded-full bg-white border border-slate-200 text-[#0A192F]"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {open && (
          <div
            data-testid="nav-mobile-menu"
            className="lg:hidden pb-5 pt-2 flex flex-col gap-1 bg-white/95 backdrop-blur-xl -mx-5 sm:-mx-8 px-5 sm:px-8 border-t border-slate-200"
          >
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 rounded-lg text-base font-medium text-slate-800 hover:bg-slate-100"
                data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href={`tel:${PHONE_TEL}`}
              className="mt-2 sm:hidden inline-flex items-center justify-center gap-2 rounded-full bg-[#0A192F] text-white px-5 py-3 text-sm font-semibold"
              data-testid="nav-mobile-phone-cta"
            >
              <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
